export default "__VITE_ASSET__CpufOxEn__"